import React from 'react'
import {connect} from "react-redux";
import { v4 as uuid } from 'uuid';

const mapStateToProps = (state, ownProps) => ({
    ...state
});

class Validation extends React.Component {

    constructor(props) {
        super(props)
        this.formId = uuid();
    }


    render() {
        window.location.href = 'https://www.zoonbadkamers.nl/bedankt?id=' + this.formId;
        return null;
    }

}

export default connect(mapStateToProps)(Validation);
